export default "__VITE_ASSET__jmTRqjBA__"